// extracted by mini-css-extract-plugin
module.exports = {"cross":"styles_cross__3V9PY","spin":"styles_spin__3Z_-8"};